const styles = {
	logo: {
		fontFamily: "'IBM Plex Mono', monospace",
		fontSize: 36,
		letterSpacing: 2,
		textAlign: 'center',
		marginBottom: 6,
		color: '#000',
	},
	developer: {
		textAlign: 'center',
		fontSize: 12,
		color: '#000',
		marginBottom: 10,
		textTransform: 'lowercase',
		opacity: 0.9,
	},
	name: {
		textAlign: 'center',
		fontWeight: 700,
		fontSize: 18,
		fontFamily: "'Tiny5', sans-serif",
		color: '#1b1883',
		margin: '6px 0 4px',
	},
	subtitle: {
		textAlign: 'center',
		color: '#333',
		fontSize: 13,
		marginBottom: 12,
	},
	socialRow: {
		display: 'flex',
		justifyContent: 'center',
		gap: 16,
		marginBottom: 20,
	},
	socialIcon: {
		color: '#000',
		fontSize: 18,
		opacity: 0.95,
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 36,
		height: 36,
		borderRadius: 8,
		background: 'transparent',
	},
	projectsTitle: {
		fontSize: 13,
		fontWeight: 700,
		margin: '8px 0 10px',
		color: '#111',
	},
	linkButton: {
		display: 'block',
		textAlign: 'center',
		width: '100%',
		padding: '14px 18px',
		borderRadius: 28,
		background: '#fff',
		color: '#000',
		textDecoration: 'none',
		border: '4px solid #000',
		fontWeight: 700,
		marginBottom: 25, // aumentado para más espacio entre botones
		boxSizing: 'border-box',
		fontSize: 16,
		boxShadow: '3px 3px 0 #000',
		backgroundClip: 'padding-box',
	},
	cv: {
		display: 'block',
		textAlign: 'center',
		width: '100%',
		marginTop: 12,
		padding: '12px 18px',
		borderRadius: 28,
		background: '#000', // fondo negro
		color: '#fff', // letras blancas
		textDecoration: 'none',
		fontWeight: 700,
		border: 'none',
		boxSizing: 'border-box',
		/* sombra en el color solicitado (#ccc) */
		boxShadow: '6px 6px 0 #ccc',
	},
	smallDisabled: { color: '#666', fontSize: 13 },
	avatarImg: {
		/* ahora usado como contenedor con background-image */
		width: 96,
		height: 96,
		borderRadius: '50%',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
		display: 'block',
		margin: '0 auto 12px',
		border: '3px solid #000',
	},
	avatarInitials: {
		width: 96,
		height: 96,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		margin: '0 auto 12px',
		background: '#000',
		color: '#fff',
		fontWeight: 700,
		fontSize: 28,
		border: '3px solid #000',
	},
};

export default styles;
